<script>
  import { _, locale } from 'svelte-i18n';
  import { onMount } from 'svelte';
  import { getConfig } from '@app/config';
  import { currentPage } from '@store/route-store';
  import { darkModeEnabled } from '@store/dark-mode-store';

  export let copyrightText;
  export let logo;
  export let buildVersion;

  function getFooterConfig(currentPage) {
    return getConfig().modules[currentPage.category].footer;
  }
</script>
<footer class="footer" lang="{$locale}">
  <div class="footer__logo">
    <img src="{$darkModeEnabled ? logo.dark.url : logo.light.url}" alt="">
  </div>
  <div class="footer__links">
      <span class="footer__links__copyright">
        Copyright &copy; <span class="footer__links__copyright-emphasized">{copyrightText}</span>
      </span>
      <span class="footer__links__add">
        {#if $currentPage != null}
          <a href="{getFooterConfig($currentPage).addLink.url}" target="_blank">
            {#if $currentPage.category === 'events'}
              {$_('common.add_event')}
            {:else if $currentPage.category === 'activities'}
              {$_('common.add_activity')}
            {/if}
          </a>
        {/if}
      </span>
      <span class="footer__links__license">
        <a href="https://creativecommons.org/licenses/by/4.0/deed.fi" target="_blank">
          {$_('common.data_licensed')} CC BY 4.0
        </a>
      </span>
      {#if buildVersion != null}
        <span class="font-mono hidden">
          (build: {buildVersion})
        </span>
      {/if}
  </div>
</footer>
